import { PageLayout, Viewer, Worker } from '@react-pdf-viewer/core';
import {
  RenderCurrentScaleProps,
  RenderZoomOutProps,
  ZoomInIcon,
  ZoomOutIcon,
  zoomPlugin,
} from '@react-pdf-viewer/zoom';
import classNames from 'classnames';
import { CSSProperties } from 'react';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import '@react-pdf-viewer/zoom/lib/styles/index.css';

export interface PdfViewerProps {
  src: string;
  enableZoom?: boolean;
  defaultScale?: number;
  className?: string;
  hidePageShadow?: boolean;
  removeFirstPageTopPadding?: boolean;
}

export const PdfViewer = ({
  src,
  enableZoom,
  defaultScale = 0.8,
  className,
  hidePageShadow = false,
  removeFirstPageTopPadding = false,
}: PdfViewerProps) => {
  // const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const zoomPluginInstance = zoomPlugin();
  const { CurrentScale, ZoomIn, ZoomOut } = zoomPluginInstance;
  const pageLayout: PageLayout = {
    buildPageStyles: ({ pageIndex }) => ({
      paddingTop: pageIndex === 0 ? (removeFirstPageTopPadding ? '0px' : '16px') : '0px',
      paddingBottom: '16px',
    }),
  };

  return (
    <div
      className={classNames('flex flex-col overflow-hidden', className)}
      style={
        hidePageShadow
          ? ({
              '--rpv-core__page-layer-box-shadow': 'none',
            } as CSSProperties)
          : undefined
      }
    >
      {enableZoom && (
        <div className="shrink-0 h-8 flex gap-4 justify-end mb-6 [&_svg]:w-[20px] [&_svg]:h-[20px] [&>*]:h-full">
          <ZoomOut>
            {(props: RenderZoomOutProps) => (
              <button className="hover:bg-[rgba(0,0,0,0.1)] px-2 rounded" onClick={props.onClick}>
                <ZoomOutIcon />
              </button>
            )}
          </ZoomOut>

          <CurrentScale>
            {(props: RenderCurrentScaleProps) => (
              <span className="leading-[30px]">{`${Math.round(props.scale * 100)}%`}</span>
            )}
          </CurrentScale>
          <ZoomIn>
            {(props: RenderZoomOutProps) => (
              <button className="hover:bg-[rgba(0,0,0,0.1)] px-2 rounded" onClick={props.onClick}>
                <ZoomInIcon />
              </button>
            )}
          </ZoomIn>
        </div>
      )}

      <div className="min-h-0 flex-1 overflow-hidden pb-6">
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@6.2.108/build/pdf.worker.min.mjs">
          <Viewer
            fileUrl={src}
            defaultScale={defaultScale}
            theme="light"
            pageLayout={pageLayout}
            plugins={enableZoom ? [zoomPluginInstance] : []}
          />
        </Worker>
      </div>
    </div>
  );
};
